import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import StringCell from '@/backgrid/StringCell';
import DollarCell from '@/backgrid/DollarCell';

import OrderSummaryGridView from '../../../views/OrderSummaryGridView/OrderSummaryGridView';

import tmplVB0SummaryView from './VB0SummaryView.hbs';

const VB0SummaryView = View.extend({
  template: tmplVB0SummaryView,

  className: 'vb0-summary-view',

  ui: {
    summaryTable: '.summary-table'
  },

  regions: {
    summaryTable: '@ui.summaryTable'
  },

  onRender() {
    this.columns = [
      {
        name: 'item',
        label: 'Item',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'quantity',
        label: 'Quantity',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'totalPrice',
        label: 'Total Price',
        cell: DollarCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      }
    ];

    this.collection = new Backbone.Collection([
      {
        item: 'Desktop MFDs and Printers',
        quantity: this.model.get('order').totalPrinterQuantity,
        totalPrice: this.model.get('order').totalPrinterPrice
      },
      {
        item: 'Desktop Scanners',
        quantity: this.model.get('order').totalScannerQuantity,
        totalPrice: this.model.get('order').totalScannerPrice
      },
      {
        item: 'Toner Cartridges/Paper Trays',
        quantity: this.model.get('order').totalTonerPaperQuantity,
        totalPrice: this.model.get('order').totalTonerPaperPrice
      },
      {
        item: 'Order Total',
        quantity: this.model.get('order').totalOrderQuantity,
        totalPrice: this.model.get('order').totalOrderPrice
      }
    ]);

    this.orderSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.collection,
      columns: this.columns
    });
    this.showChildView('summaryTable', this.orderSummaryGridView);
  }
});

export default VB0SummaryView;
